<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeDetailAccount from '../../../../../../employees/components/EmployeeDetailAccount.vue'

import { Employee } from '../../../../../../employees/models/employee'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { employee } = defineProps<{
  employee: Employee
}>()
</script>

<template>
  <EmployeeDetailAccount :employee="employee" />
</template>
